import type { Network } from './interfaces';

const NETWORK_TO_SCAN: Record<Network, string> = {
  mainnet: 'https://etherscan.io/address/',
  rinkeby: 'https://rinkeby.etherscan.io/address/',
  goerli: 'https://goerli.etherscan.io/address/',
  polygon: 'https://polygonscan.com/address/',
  mumbai: 'https://mumbai.polygonscan.com/address/',
  arbitrum: 'https://arbiscan.io/address/',
  optimism: 'https://optimistic.etherscan.io/address/',
  gnosis: 'https://gnosisscan.io/address/',
  tezos: 'https://tzstats.com/',
};

export const NETWORK_TO_ICON: Record<Network, string> = {
  mainnet: 'icon-ethereum',
  rinkeby: 'icon-ethereum',
  goerli: 'icon-ethereum',
  polygon: 'icon-polygon',
  mumbai: 'icon-polygon',
  arbitrum: 'icon-arbitrum',
  optimism: 'icon-optimism',
  gnosis: 'icon-gnosis',
  tezos: 'icon-xtz',
};

export const getContractUrl = (network: Network, address: string): string =>
  NETWORK_TO_SCAN[network] + address;
